import React, {useState, useEffect} from 'react';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import MarqueeComponent from '../component/MarqueeComponent'
import { slides } from '../component/data.js'
import Newsletter from '../component/Newsletter.jsx';
import Testimonial from '../component/Testimonial.jsx';
import ShippingSection from '../component/ShippingSection.jsx';
import SwiperSection from '../component/SwiperSection.jsx';
import ProductSection from '../component/ProductSection.jsx';
import VideoSection from '../component/VideoSection.jsx';
import HomepageBlog from '../component/HomepageBlog.jsx';
import WhatsappButton from '../component/WhatsappButton.jsx';
import BannerSection from './BannerSection.jsx';
import APIs from '../redux/apiUrl.js';



const LandingPage = () => {
  const [marqueeTexts, setMarqueeTexts] = useState([
    'Discover the best interior furniture!',
    'Modern, Stylish, and Affordable!',
    'Shop Now and Elevate Your Space!',
    'Limited Time Offers!',
  ]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchMarqueeTexts = async () => {
      try {
        setLoading(true);
        const response = await APIs.get('/get_all_macue/1/10');

        if (response.data && response.data.data && response.data.data.docs) {

          const texts = response.data.data.docs.map(
            item => item.text || item.content || item.message || item.title
          );

          if (texts.length > 0) {
            setMarqueeTexts(texts);
          }
        }
      } catch (error) {
        console.error('Failed to fetch marquee texts:', error);
        // Keep using the default texts if there's an error
      } finally {
        setLoading(false);
      }
    };

    fetchMarqueeTexts();
  }, []);

  return (
    <div className="store-home">
    <div className="store-announcement"><MarqueeComponent texts={marqueeTexts} /></div>
    <section className="hero__slider--section">
        <Swiper
          modules={[Autoplay, Navigation, Pagination]}
          autoplay={{ delay: 5000 }}
          navigation
          pagination={{ clickable: true }}
          loop
          className="hero__slider--inner mb-8"
        >
          {slides.map((slide) => (
            <SwiperSlide key={slide.id} className={`hero__slider--bg ${slide.className}`}>
              <div className="hero__slider--items">
                <div className="container-fluid">

                  <div className="hero__slider--items__inner">
                    <div className="row row-cols-1">
                      <div className="col">
                        <div className="slider__content">
                          <p className="slider__content--desc text-white text-xl mb-15 font-bold">
                            {slide.content.desc}
                          </p>
                          <h2 className="slider__content--maintitle text-white h1">
                            {slide.content.title}
                          </h2>
                          <p className="slider__content--desc text-white mb-35 font-medium text-xl">
                            {slide.content.subDesc}
                          </p>
                          <a
                            className="slider__content--btn primary__button"
                            href={slide.content.link}
                          >
                            Explore the collection
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </section>

      <div className="store-benefits store-shell"><div><strong>Professional essentials</strong><span>For salons, spas & beauty spaces</span></div><div><strong>Shop your way</strong><span>Explore equipment and accessories</span></div><div><strong>Here to help</strong><a href="/contact_us">Talk to our team before you buy →</a></div></div>
      <BannerSection />


      <ProductSection />
      <VideoSection />
      <ShippingSection />
      <Testimonial />
      <Newsletter />
      <HomepageBlog />
      <SwiperSection />
      <WhatsappButton />
    </div>
  );
};

export default LandingPage;
